import { PaginationQuery, PaginationQueryDefaultValues } from "../pagination/pagination-query"
import { CourseType } from "./course-type"

export interface CourseList{
    id: string,
    courseName: string,
    courseDescription: string,
    courseId: string,
    programs: string,
    enrollment: string,
    status: string,
  
}

export function CourseListDefaultValues():CourseList
{
    return {
      id: '',
      courseName: '',
      courseDescription: '',
      courseId: '',
      programs: '',
      enrollment: '',
      status: '',
      
    }
}

export type CourseQueryFilter = PaginationQuery & {
    CourseKeyword: string,
    CourseProgram: number,
    Tag: number,
    CourseStatus: number,
    ProgramMode?: string
}

export function CourseQueryFilterDefaultValues(): CourseQueryFilter
{
    return {
      ...PaginationQueryDefaultValues(),
      CourseKeyword: '',
      CourseProgram: 0,
      Tag: 0,
      CourseStatus: 0,
      ProgramMode: ''
    }
}

